import React from 'react';

export default function SingleTickIcon() {
	return (
		<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.5 14.3636V18.9091L13.5909 28L29.5 7.54545V3L13.5909 23.4545L4.5 14.3636Z"
				fill="black"
			/>
		</svg>
	);
}
